import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import fr from 'facet-rest';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import Content from '../Content';
import metaOverrideSet from '../MetaOverrideSet';

const styles = () => ({
  root: {},
});

const AccountOpeningAgreementForActivationTemplate = ({
  className,
  classes,
  resource,
}) => {
  return (
    <WizardStepWrapperTemplate
      className={classNames(className, classes.root)}
      metaOverrideSet={metaOverrideSet}
      resource={resource}
      layout={Content}
      LayoutProps={{
        ErrorListProps: {
          scrollIntoView: true,
        },
      }}
    />
  );
};

AccountOpeningAgreementForActivationTemplate.defaultProps = {
  className: '',
};

AccountOpeningAgreementForActivationTemplate.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default withStyles(styles)(AccountOpeningAgreementForActivationTemplate);
